import axios from "axios";
import { getAuthHeader } from "../utils/AuthUtils";
const USER_API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BASE_ROUTE = "/api/v1/cart";

class CartService {
  static async postCollectSize(data) {
    return axios.post(`${USER_API_BASE_URL}${BASE_ROUTE}/collectSize`, data);
  }

  static async addToCart(data) {
    return axios.post(
      USER_API_BASE_URL + BASE_ROUTE + "/item",
      data,
      getAuthHeader()
    );
  }

  static async updateCollectable(data) {
    return axios.put(
      USER_API_BASE_URL + BASE_ROUTE + "/collectable",
      data,
      getAuthHeader()
    );
  }

  static async getCartItems() {
    return axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}/items`,
      getAuthHeader()
    );
  }

  static async updateSingleCartItemSizes(data) {
    return axios.put(
      `${USER_API_BASE_URL}${BASE_ROUTE}/item/sizes`,
      data,
      getAuthHeader()
    );
  }

  static async removeCartItem(id) {
    return axios.delete(
      `${USER_API_BASE_URL}${BASE_ROUTE}/item/${id}`,
      getAuthHeader()
    );
  }

  static async updateShippingMethod(factoryId, shippingTier) {
    return axios.put(
      `${USER_API_BASE_URL}${BASE_ROUTE}/item/shippingmethod`,
      { factoryId, shippingTier },
      getAuthHeader()
    );
  }

  static async updateAdditionalOptions(factoryId, fieldName, value) {
    return axios.put(
      `${USER_API_BASE_URL}${BASE_ROUTE}/item/additionalOptions`,
      { factoryId, fieldName, value },
      getAuthHeader()
    );
  }

  static async updateCarbonNeutral(carbonNeutral) {
    return null;
    // eslint-disable-next-line no-unreachable
    return axios.put(
      `${USER_API_BASE_URL}${BASE_ROUTE}/carbonneutral`,
      { carbonNeutral },
      getAuthHeader()
    );
  }
}

export default CartService;
